import { gql } from "apollo-boost";

export const LOG_IN = gql`
  mutation LogIn($input: LogInInput) {
    logIn(input: $input) {
      id
      name
      avatar
      email
      token
      hasWallet
      didRequest
    }
  }
`;
